module.exports = __webpack_public_path__ + "media/images/icons/twotone/file-f205d93a65203c90f3138bcb4b0d5019.svg";